angular.module('siter.io').factory 'Templates', ["Restangular", "$rootScope", "$stateParams", "$state", (Restangular, $rootScope, $stateParams, $state) ->
  'use strict'

  templates =
    getAll: (category) ->
      Restangular.one("templates.json").get {tag: category}
    get: ->
      Restangular.all("templates").one($state.params.templateSlug+".json").get()
    getOne: ->
      Restangular.all("templates").one($state.params.templateId+".json").get()
    set: (template_id) ->
      Restangular.all("sites").one($state.params.siteId).all("site_templates.json").post({template_id: template_id})
    getUserCategories: ->
      Restangular.all("templates").all("tags?user_tags=1").getList()
    sortCategories: (tags) ->
      Restangular.all("templates").all("tags_sort").post tags:tags


  templates
]



// WEBPACK FOOTER //
// ./src/app/site/set_template/templates.service.coffee